<calcite-shell>
  @if (!isAuthPage()) {
    <calcite-navigation slot="header">
      <calcite-navigation-logo slot="logo" heading="Paramount" thumbnail="/paramount-icon.png" routerLink="/"/>

      <calcite-menu slot="content-center" layout="horizontal" label="Primary navigation">
        @for (tab of tabs; track tab.route) {
          <calcite-menu-item
            [text]="tab.label"
            [iconStart]="tab.icon"
            [active]="isActiveTab(tab.route)"
            [routerLink]="tab.route"
          />
        }
      </calcite-menu>

      <calcite-action
        slot="content-end"
        icon="search"
        text="Search"
        title="Open command palette (Ctrl/Cmd+K)"
        (click)="triggerSearch()"
      />

      @if (currentUser(); as $user) {
        <calcite-navigation-user
          slot="user"
          [fullName]="$user.display_name"
          [username]="$user.email"
          [thumbnail]="$user.avatar_url || undefined"
        />

        <calcite-dropdown slot="user" placement="bottom-end">
          <calcite-action
            slot="trigger"
            icon="hamburger"
            text="Menu"
          ></calcite-action>

          <calcite-dropdown-group>
            <calcite-dropdown-item icon-start="sign-out" (click)="signOut()">Logout</calcite-dropdown-item>
          </calcite-dropdown-group>
        </calcite-dropdown>
      }
    </calcite-navigation>
  }

  <!--
    calcite-shell's own content area is a flex column with
    justify-content: space-between. Angular's <router-outlet> renders as
    an empty sibling element immediately before the routed component; with
    no grouping wrapper, that anchor and the routed content become two
    separate flex items, and space-between bottom-anchors the real content
    instead of placing it right after the nav. This calcite-panel bundles
    router-outlet + routed content into a single flex item so that layout
    quirk doesn't apply, and doubles as the one page-level heading/description
    panel for the whole app (see PageInfoService) — routed pages project
    their content straight into it via <ng-content>, no per-page panel needed.
  -->
  <calcite-panel [heading]="pageInfo.heading()" [description]="pageInfo.description()">
    <ng-container [ngTemplateOutlet]="pageInfo.headerActions()"/>
    <ng-content/>
  </calcite-panel>
</calcite-shell>
